import { page, shows, type FeatureRoutes } from "@/app/feature";

export const routes: FeatureRoutes = {
  // An invite or creator code's link opens signed out too (docs/architecture/growth.md); the edge serves it with
  // the code's link-preview tags.
  public: [
    { path: "r/:code", lazy: page(() => import("./InvitePage")), handle: shows("growth") },
    // The pioneers' call (docs/marketing/france-launch.md §4): public, signed in or not.
    { path: "pionniers", lazy: page(() => import("./launch/PioneersPage")), handle: shows("growth") },
  ],
  shell: [{ path: "invite", lazy: page(() => import("./MyInvitePage")), handle: shows("growth") }],
};
